exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#qualifications-container {\n  margin: 0 auto; }\n\n#qualifications-content, #qualifications-content__failed, #qualifications-content__transmitting {\n  padding: 2vh 5vw 0 5vw; }\n\n#qualifications-content__failed {\n  padding-top: 2vh; }\n\n#qualifications-content__transmitting {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  margin: 5vh; }\n\n.qualifications-button {\n  margin-top: 5%; }\n\n#questions-content {\n  width: 96%;\n  margin: 0 auto; }\n\n.addressinfo-container {\n  margin: 0 auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/css-loader!/root/social-native/socialnative-web/node_modules/postcss-loader/src??ref--4-2!/root/social-native/socialnative-web/node_modules/sass-loader/lib/loader.js!./components/campaign_qualification_container/index.scss
// module id = 3378
// module chunks = 69